import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { PreOrderListModel, PreOrderListModelList } from '../models/models'

export class GetPreOrderListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/preOrder/listPreOrder',
      requesterInfo,
    })
  }

  public async getPreOrderList(): Promise<PreOrderListModelList[]> {
    return await this.getAsync<PreOrderListModelList[]>()
  }
}
